import {
  SET_DASHBOARD,
  GET_DASHBOARD_REQUEST,
  DASHBOARD_CHANGE_OUTLET,
  DASHBOARD_CHANGE_DATE,
  DASHBOARD_SET_OUTLETS,
  DASHBOARD_PAGE_REQUEST,
  DASHBOARD_SET_ASYNC_FLAG,
  DASHBOARD_SET_FILTER_DATA_ASYNC,
  DASHBOARD_GET_DATA_URL_ASYNC,
  DASHBOARD_SET_FLAG_ERROR_PUSHER_DASHBOARD
} from './constants'

export function setDashboard (data) {
  return {type: SET_DASHBOARD, payload: {dashboard: data}}
}

export function setOutlets (outlets) {
  return {type: DASHBOARD_SET_OUTLETS, payload: {outlets}}
}

export function getDashboardRequest (query) {
  return {type: GET_DASHBOARD_REQUEST, payload: {query}}
}

export function changeOutlet (outletIds, startDate, endDate) {
  return {type: DASHBOARD_CHANGE_OUTLET, payload: {outletIds, startDate, endDate}}
}

export function changeDate (startDate, endDate, outlet) {
  return {type: DASHBOARD_CHANGE_DATE, payload: {startDate, endDate, outlet}}
}

export function pageRequest (flagAsync, outletsAsync, startDateAsync, endDateAsync, currentDashboardData) {
  return {type: DASHBOARD_PAGE_REQUEST, payload: {flagAsync, outletsAsync, startDateAsync, endDateAsync, currentDashboardData}}
}

export function setFlagAsyncDashboard (flag) {
  return {type: DASHBOARD_SET_ASYNC_FLAG, payload: {flag}}
}

export function setFilterDataAsyncDashboard (outletIdsAsync, startDateAsync, endDateAsync) {
  return {type: DASHBOARD_SET_FILTER_DATA_ASYNC, payload: {outletIdsAsync, startDateAsync, endDateAsync}}
}

export function getDataAsyncDasboardUrls3 (results, filterHeader) {
  return {type: DASHBOARD_GET_DATA_URL_ASYNC, payload: {results, filterHeader}}
}

export function setFlagErrorPusherAsyncDashboard (errorPusher) {
  return {type: DASHBOARD_SET_FLAG_ERROR_PUSHER_DASHBOARD, payload: {errorPusher}}
}



// WEBPACK FOOTER //
// ./app/actions/dashboard/index.js